import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { GroupsService } from '../../../groups-schedule/group-list/group-list.service';
import { UserstorageService } from '../../userstorage/userstorage.service';
import { AuthService } from './auth.service';
import { Location } from '@angular/common';
import { UrlAccessService } from '../../../url-access/url-access.servvice';
import { AccountFeaturesService } from '../../../account-features/account-features.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  abilities: any;
  simplifiedMenuItems: any;
  constructor( private authService: AuthService,  
    private router: Router,
    private aroute: ActivatedRoute,
    private groupService: GroupsService,
    private _userStorageService:UserstorageService,
    private location: Location, private urlAccessService: UrlAccessService,
    private accountFeaturesService : AccountFeaturesService
   ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    const hasToken = !!this.getToken();
    const requestedPath = this.getRequestedPath(state?.url);
    const requestedSegments = this.getPathSegments(requestedPath);
    if (currentUser || hasToken) {
      let isAccessPage = await this.groupService.getAbilities(this.getToken()).toPromise();
      this.abilities = isAccessPage[0];
      this.simplifiedMenuItems = this.urlAccessService.getPermissionCheck(this.abilities);
      let accName = this.getSubdomain();
      let urlAccName = this.getSubdomainFromUrl(requestedPath);
      if (accName) { //Check account name is valid and page url is exist
        if (urlAccName.toLowerCase() != accName.toLowerCase()) {
          const redirect = this.redirectIfNeeded(
            this.urlAccessService.getActualRedirectUrl(this.abilities, accName, currentUser),
            state.url
          );
          if (redirect) {
            return redirect;
          }
        }
        const urlHost = requestedSegments;
        if (urlHost.length > 2) {
          if (urlHost[2].length == 1) {
            const originalRequestUrl = state.url;
            if (this.isOldUrl(originalRequestUrl)) {
              const res = this.getRedirectUrl(originalRequestUrl, urlHost[2])
              const redirect = this.redirectIfNeeded(res ? res : '/error/404', state.url);
              if (redirect) {
                return redirect;
              }
            }
          } else if (route.routeConfig.path === '**') {
            const redirect = this.redirectIfNeeded('/error/404', state.url);
            if (redirect) {
              return redirect;
            }
          }
          else {
            let pageUrl = urlHost.length > 2 ? urlHost[2] : '';
            if(pageUrl == 'integrations' || pageUrl == 'administration') { 
              pageUrl = urlHost[3] ? urlHost[3] : pageUrl;
            }
            if (pageUrl == 'users' && urlHost[3]) {
              if (urlHost[3] == 'add') {
                pageUrl = 'add-user';
              }
            }
            if (pageUrl === 'status-main-page') {
              return true;
            }
            if (!pageUrl) {
              const redirect = this.redirectIfNeeded(
                this.urlAccessService.getActualRedirectUrl(this.abilities, accName, currentUser),
                state.url
              );
              if (redirect) {
                return redirect;
              }
            } else {
              let selectedPage = this.simplifiedMenuItems.find(data => data.page == pageUrl);
              if(selectedPage?.permissions) {
                if (window.history.length > 2) {
                  const urlWithoutQueryParams = window.location.href.split('?')[0];
                  window.history.replaceState({}, document.title, urlWithoutQueryParams);
                  this.location.back();
                  return true
                } else {
                  const urlWithoutQueryParams = window.location.href.split('?')[0];
                  window.history.replaceState({}, document.title, urlWithoutQueryParams);
                  const redirect = this.redirectIfNeeded(
                    this.urlAccessService.getActualRedirectUrl(this.abilities, accName, currentUser),
                    state.url
                  );
                  if (redirect) {
                    return redirect;
                  }
                }
              }
            }
          }
        } else {
          const redirect = this.redirectIfNeeded(
            this.urlAccessService.getActualRedirectUrl(this.abilities, accName, currentUser),
            state.url
          );
          if (redirect) {
            return redirect;
          }
        }
      }
      return true;
    }
    const currentUrl = state.url;
    //checking app login status to store url path in cache if not login
    const loginFlag = localStorage.getItem('addLoginFlag');
    if(loginFlag=='no'){
      localStorage.setItem('addUrlToCache',currentUrl);
    }else {
      localStorage.setItem('addUrlToCache','');
    }
    this.authService.logoutFromAuthGaurd();
    return false;
  }

  isOldUrl(url: string): boolean {
    return true;
}

getRedirectUrl(url: string, oldURL: string): string {
  let redirectUrl;
    if(oldURL === 'i') {
      redirectUrl = url.replace('/i/','/business-services/incidents/detail/');
    }
    return redirectUrl;
}
  getSubdomain() {
    const loginDt = JSON.parse(localStorage.getItem('token-key'));
    let accountKey = loginDt?.account? loginDt?.account : '';
    // const hostUrl = window.location.pathname;
    // const urlHost = hostUrl.split('/');
    // // let accountKey = "";
    // if (urlHost.length > 0) {
    //   accountKey = urlHost[1];
    // }
    return accountKey;
  }

  getSubdomainFromUrl(path?: string) {
    const urlHost = this.getPathSegments(path || window.location.pathname);
    let accountKey = '';
    if (urlHost.length > 0) {
      accountKey = urlHost[1] || '';
    }
    return accountKey;
  }

  getToken() {
    return this._userStorageService.getToken();
  }

  private redirectIfNeeded(target: string, currentUrl?: string) {
    if (!target) {
      return null;
    }
    const currentPath = (currentUrl || this.router.url || window.location?.pathname || '')
      .split('?')[0]
      .split('#')[0];
    const targetPath = target.split('?')[0].split('#')[0];
    if (currentPath === targetPath) {
      return null;
    }
    return this.router.parseUrl(target);
  }

  private getRequestedPath(url?: string): string {
    const rawUrl = String(url || this.router.url || window.location?.pathname || '').trim();
    const withoutQuery = rawUrl.split('?')[0].split('#')[0].trim();
    if (!withoutQuery) {
      return '/';
    }
    return withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  }

  private getPathSegments(path?: string): string[] {
    const normalizedPath = this.getRequestedPath(path);
    return normalizedPath.split('/');
  }
}
